import './NavBar.css';
import { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import profilephoto from '../assets/img/profile-photo.jpeg';

export const NavBar = () => {
  const [activeLink, setActiveLink] = useState('home');
  const [scrolled, setScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onNavClick = (value) => {
    setActiveLink(value);
    setExpanded(false);
  };

  const navItems = [
    { key: 'home', label: 'Home', href: '#home' },
    { key: 'about', label: 'About', href: '#about' },
    { key: 'experience', label: 'Experience', href: '#experience' },
    { key: 'skills', label: 'Skills', href: '#skills' },
    { key: 'portfolio', label: 'Portfolio', href: '#portfolio' },
  ];

  return (
    <Navbar
      expand="lg"
      expanded={expanded}
      onToggle={setExpanded}
      className={`navbar-main ${scrolled ? "scrolled" : ""}`}
    >
      <Container>
        <Navbar.Brand
          href="#home"
          className="navbar-brand"
          onClick={() => onNavClick('home')}
        >
          <img
            src={profilephoto}
            alt="Profile"
            className="navbar-profile-img"
          />
          <span className="navbar-name">Evans Kariuki</span>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" className="navbar-toggler">
          <span className="navbar-toggler-icon"></span>
        </Navbar.Toggle>

        <Navbar.Collapse id="basic-navbar-nav" className="navbar-collapse">
          <Nav className="navbar-nav ms-auto">
            {navItems.map((item) => (
              <Nav.Link
                key={item.key}
                href={item.href}
                className={`nav-link ${activeLink === item.key ? 'active' : ''}`}
                onClick={() => onNavClick(item.key)}
              >
                {item.label}
              </Nav.Link>
            ))}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};
